import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

const PALETTE = {
  "Floral":           { gradient: "linear-gradient(160deg,#c8c0b0,#b0a898)", emoji: "🌸", sub: "Soft & Romantic"  },
  "Woody":            { gradient: "linear-gradient(160deg,#c8a96e,#a88848)", emoji: "🪵", sub: "Warm & Earthy"    },
  "Fresh":            { gradient: "linear-gradient(160deg,#3a6b4e,#2a5038)", emoji: "🍃", sub: "Clean & Airy"     },
  "Spice":            { gradient: "linear-gradient(160deg,#c8832a,#a86020)", emoji: "🌶️", sub: "Sweet & Vibrant"  },
  "container candles":{ gradient: "linear-gradient(160deg,#b0a898,#8a8070)", emoji: "🕯️", sub: "Classic & Elegant"},
  "Pillar candles":   { gradient: "linear-gradient(160deg,#c0a878,#a08858)", emoji: "🕯️", sub: "Bold & Statement" },
  "Gifts":            { gradient: "linear-gradient(160deg,#e07b39,#c96a18)", emoji: "🎁", sub: "Perfect Presents" },
  "Festive candles":  { gradient: "linear-gradient(160deg,#c84848,#a83030)", emoji: "🪔", sub: "Celebrate in Style"},
};

function getStyle(name) {
  if (PALETTE[name]) return PALETTE[name];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  const h = Math.abs(hash) % 360;
  return { gradient: `linear-gradient(160deg,hsl(${h},45%,45%),hsl(${h},45%,32%))`, emoji: "🕯️", sub: "Handcrafted with Love" };
}

export default function CategoriesSection() {
  const navigate    = useNavigate();
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("products/categories/")
      .then(res => {
        const data = res.data?.results || res.data || [];
        setCats(Array.isArray(data) ? data : []);
      })
      .catch(() => setCats([
        { id: 1, name: "Floral" }, { id: 2, name: "Woody" },
        { id: 3, name: "Fresh" },  { id: 4, name: "Spice" },
      ]));
  }, []);

  return (
    <section id="categories" style={{ background: "#faf7f2", padding: "80px 6%" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto 40px",
        display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
        <div>
          <h2 style={{ fontFamily: "Georgia, serif", fontSize: "clamp(22px,3vw,32px)",
            color: "#1a1a1a", fontWeight: "700", marginBottom: "6px" }}>Explore Scents</h2>
          <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#888" }}>
            Find the perfect mood for every room.
          </p>
        </div>
        <button onClick={() => navigate("/products")}
          style={{ fontFamily: "Georgia, serif", color: "#e07b39",
            background: "none", border: "none", cursor: "pointer", fontSize: "12px" }}
          onMouseEnter={e => e.target.style.textDecoration = "underline"}
          onMouseLeave={e => e.target.style.textDecoration = "none"}>
          View All Categories →
        </button>
      </div>

      <div style={{ display: "grid",
        gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))",
        gap: "16px", maxWidth: "1200px", margin: "0 auto" }}>
        {cats.slice(0, 8).map(cat => {
          const style = getStyle(cat.name);
          return (
            <button key={cat.id || cat.name}
              onClick={() => navigate(`/products?category=${encodeURIComponent(cat.name.toLowerCase())}`)}
              style={{ position: "relative", borderRadius: "18px", overflow: "hidden",
                aspectRatio: "3/4", border: "none", cursor: "pointer", padding: 0,
                transition: "transform 0.3s, box-shadow 0.3s" }}
              onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 50px rgba(0,0,0,0.18)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>

              {/* Real image uploaded from admin panel */}
              {cat.image ? (
                <img src={cat.image} alt={cat.name}
                  style={{ position: "absolute", inset: 0, width: "100%",
                    height: "100%", objectFit: "cover" }} />
              ) : (
                <>
                  <div style={{ position: "absolute", inset: 0, background: style.gradient }} />
                  <div style={{ position: "absolute", inset: 0, display: "flex",
                    alignItems: "center", justifyContent: "center",
                    fontSize: "clamp(60px,7vw,90px)", opacity: 0.22 }}>
                    {style.emoji}
                  </div>
                </>
              )}

              {/* Always-on dark overlay so text stays readable over any image */}
              <div style={{ position: "absolute", inset: 0,
                background: cat.image
                  ? "linear-gradient(to top,rgba(0,0,0,0.72) 0%,rgba(0,0,0,0.12) 55%,transparent 100%)"
                  : "linear-gradient(to top,rgba(0,0,0,0.52) 0%,transparent 55%)" }} />

              {/* Category label */}
              <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "20px 18px" }}>
                <div style={{ fontFamily: "Georgia, serif", fontSize: "18px",
                  fontWeight: "700", color: "#fff", marginBottom: "3px",
                  textAlign: "left", textShadow: "0 1px 6px rgba(0,0,0,0.5)" }}>
                  {cat.name}
                </div>
                <div style={{ fontFamily: "Georgia, serif", fontSize: "10px",
                  textTransform: "uppercase", letterSpacing: "0.12em",
                  color: "rgba(255,255,255,0.72)", textAlign: "left" }}>
                  {style.sub}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}